module.exports = __webpack_public_path__ + "static/foundation-b91018023f55d6261e7e6936ba0b7540.jpg";